// export const baseUrl = "https://devapi.chitbid.com"



/** Production nginx serves the API under /api; local Node listens at route root (/otp/send). */

function normalizeApiBaseUrl(raw) {

    const trimmed = String(raw || "https://testapp.chitbid.com/api").replace(/\/+$/, "");

    try {

        const parsed = new URL(trimmed);

        const isDirectNode =

            parsed.port === "7061" ||

            parsed.hostname === "localhost" ||

            parsed.hostname === "127.0.0.1" ||

            /^192\.168\.|^10\.|^172\.(1[6-9]|2\d|3[01])\./.test(parsed.hostname);

        if (isDirectNode && trimmed.endsWith("/api")) {

            return trimmed.slice(0, -4);

        }

    } catch {

        /* keep trimmed */

    }

    return trimmed;

}



/**

 * In local dev, use relative URLs so CRA's package.json "proxy" forwards to the

 * backend (same origin from the browser → no CORS). Set REACT_APP_USE_PROXY=false

 * to call REACT_APP_API_BASE_URL directly (e.g. LAN IP testing from phone).

 */

function getBaseUrl() {

    if (

        process.env.NODE_ENV === "development" &&

        process.env.REACT_APP_USE_PROXY !== "false"

    ) {

        return "";

    }

    return normalizeApiBaseUrl(process.env.REACT_APP_API_BASE_URL);

}



const baseUrl = getBaseUrl();

const siteUrls = {

    auth: {

        mobileSignup: `${baseUrl}/otp/send`,

        mobileSignupVerify: `${baseUrl}/otp/verify`,

        emailOtpSend: `${baseUrl}/otp/send/email`,

        emailOtpVerify: `${baseUrl}/otp/verify/email`,

        emailValidation: `${baseUrl}/auth/emailValidation`,

        profile: `${baseUrl}/profile`

    },

    time: {

        index: `${baseUrl}/auth/demo-slot?date=`,

    },

    demo: {

        post: `${baseUrl}/book-a-demo`

    },

    companyRegister: {

        post: `${baseUrl}/companyRegister`

    },

    imageUpload: {

        singleUpload: {

            post: `${baseUrl}/auth/upload`

        }

    },



}



export default siteUrls;        


